import AboutCarts from "./AboutCarts";
import TrainersIcon from "../../images/who-we-are/weightlifter.png";
import ModernIcon from "../../images/who-we-are/equpments.png";
import LiftIcon from "../../images/who-we-are/gym.png";
import GirlRunning from "../../images/who-we-are/girl-run.png";
import GirlRedBg from "../../images/who-we-are/girl-redbg.svg";
import GirlText from "../../images/who-we-are/girl-side-text.png";
import GirlWind from "../../images/who-we-are/wind.png";
import MainButton from "../MainButton";

function About() {
  return (
    <>
      <section className="flex flex-col justify-between gap-2 about-section pb-16 sm:pb-24 md:pb-32 lg:pb-[200px]">
        <div className="container page-padding">
          {/* about cards */}
          <div className="about-cards grid grid-cols-1 md:grid-cols-3 gap-6 pt-12 sm:pt-16 md:pt-20 relative z-20">
            <AboutCarts />
          </div>

          {/* text-img div */}
          <div id="about" className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-[30px] items-center">
            {/* about text */}
            <div className="mt-12 sm:mt-16 lg:mt-[105px] relative flex flex-col items-center lg:items-start text-center lg:text-left w-full">
              <div className="relative inline-flex items-center justify-center gap-2 bg-[#ff0336] text-white text-[12px] sm:text-[13px] uppercase font-bold tracking-[3px] px-6 py-2 rounded-lg transform -skew-x-12 shadow-lg shadow-[#ff0336]/20 mb-8 sm:mb-10">
                <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"></span>
                <span>who we are</span>
              </div>
              <h2 className="text-[24px] sm:text-[30px] md:text-[35px] font-bold leading-tight mb-4 sm:mb-6 max-w-xl">
                FAT2FIT Unisex Fitness Centre – Echanari, Coimbatore
              </h2>
              <p className="text-[14px] sm:text-[16px] text-[#646464] font-medium leading-relaxed max-w-xl">
                Established in 2026, FAT2FIT Unisex Fitness Centre is a premium fitness destination
                located in Echanari, Coimbatore. We are committed to transforming lives through
                expert coaching, modern equipment, and a supportive community for all fitness levels.
              </p>
              {/* about text icons */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mt-8 sm:mt-12 mb-8 sm:mb-12 w-full max-w-xl">
                <div className="flex flex-col items-center text-center p-4 bg-white/50 backdrop-blur-sm rounded-xl shadow-sm">
                  <img src={TrainersIcon} alt="certified_trainer_icon" className="w-[48px] sm:w-[54px] mb-3 h-auto" />
                  <h3 className="uppercase font-bold text-[16px] sm:text-[18px] leading-snug">
                    certified <br /> trainer
                  </h3>
                </div>

                <div className="flex flex-col items-center text-center p-4 bg-white/50 backdrop-blur-sm rounded-xl shadow-sm">
                  <img src={ModernIcon} alt="modern_equipment_icon" className="w-[48px] sm:w-[54px] mb-3 h-auto" />
                  <h3 className="uppercase font-bold text-[16px] sm:text-[18px] leading-snug">
                    modern <br /> equipments
                  </h3>
                </div>

                <div className="flex flex-col items-center text-center p-4 bg-white/50 backdrop-blur-sm rounded-xl shadow-sm">
                  <img src={LiftIcon} alt="unisex_gym_icon" className="w-[48px] sm:w-[54px] mb-3 h-auto" />
                  <h3 className="uppercase font-bold text-[16px] sm:text-[18px] leading-snug">
                    unisex <br />
                    friendly gym
                  </h3>
                </div>
              </div>
              {/* cta button */}
              <MainButton
                color={`!text-white`}
                bg={`bg-[#3f3f3f]`}
                cN="about-cta"
                arrowColor={`!text-white`}
                hover={`hover:bg-[#FF0336]`}
                text="Contact Us"
                goTo="/contact"
              />
            </div>
            {/* img side */}
            <div className="relative hidden lg:block">
              <img src={GirlRunning} alt="fitness_training" className="girl-running" />
              <img src={GirlRedBg} alt="bg_red" className="girl-bg" />
              <img src={GirlText} alt="bg_text" className="girl-text" />
              <img src={GirlWind} alt="bg_wind" className="girl-wind" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
